import { applyCost, canAffordCost } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';
import { queueConstruction } from '../economy/construction';
import { canQueueBuilding } from '../economy/settlementLimits';

export const buildIronMineAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement) return false;
    if (settlement.regionResources.ironDeposit <= 0) return false;
    if (!canQueueBuilding(settlement, 'ironMine')) return false;
    const cost = state.config.buildings.ironMine.cost || {};
    if (!canAffordCost(settlement, cost)) return false;
    applyCost(settlement, cost);
    queueConstruction(settlement, 'ironMine', state.simulation.tick, cost);
    return true;
};
